import Alpine, { AlpineComponent } from "alpinejs";
import { Basket, BasketItem, BasketService, CutMeasure, GoogleService } from "../api";
import { getOrderTotal } from "../utils/getOrderTotal.ts";
import { BasketNotificationStore } from "./stores/basketNotificationStore.ts";

type BuyTableComponent = AlpineComponent<{
	hangerProductId: string;
	sampleCardProductId: string;
	cutSampleProductId: string;
	cutMeasureProductId: string;
	hasCutMeasure: boolean;
	cutMeasures: CutMeasure[];
	hangerBasketLine?: BasketItem;
	sampleCardBasketLine?: BasketItem;
	cutSampleBasketLine?: BasketItem;
	cutMeasureBasketLine?: BasketItem;
	upsertCutMeasure: (mainPartNo: string, productType: string) => Promise<void>;
	addNewCutMeasure: (mainPartNo: string, productType: string) => Promise<void>;
	changeCutMeasure: (mainPartNo: string, productType: string) => Promise<void>;
}>;

export default (
	hangerProduct: string,
	sampleCardProduct: string,
	cutSampleProduct: string,
	cutMeasureProductId: string
): BuyTableComponent => {
	const addToCartTracking = async (partNo: string, quantity: number) => {
		const addToCart = await GoogleService.addToCart({
			query: {
				partNo: partNo,
				quantity: quantity,
			},
		});
		window.dataLayer.push({ ecommerce: null });
		window.dataLayer.push({
			event: "add_to_cart",
			ecommerce: addToCart.data,
		});
	};
	return {
		hangerProductId: hangerProduct,
		cutSampleProductId: cutSampleProduct,
		sampleCardProductId: sampleCardProduct,
		cutMeasureProductId: cutMeasureProductId,
		cutMeasureBasketLine: undefined,
		hasCutMeasure: false,
		hangerBasketLine: undefined,
		cutSampleBasketLine: undefined,
		sampleCardBasketLine: undefined,
		cutMeasures: [{ cutLength: "1", noOfPieces: "1" }],
		async upsertCutMeasure(mainPartNo, productType) {
			this.cutMeasures.forEach((x) => {
				let noOfPieces = parseFloat(x.noOfPieces);
				noOfPieces = Math.max(noOfPieces, 1);
				noOfPieces = Math.round(noOfPieces);
				x.noOfPieces = noOfPieces.toString();

				let cutLength = parseFloat(x.cutLength);
				cutLength = Math.ceil(cutLength * 10) / 10;
				cutLength = Math.max(cutLength, 0.5);
				x.cutLength = cutLength.toString();
			});
			let totalQuantity = this.cutMeasures.reduce((acc, x) => (acc += parseInt(x.noOfPieces)), 0);
			totalQuantity = Math.ceil(totalQuantity);
			const res = await BasketService.upsertBasketItem({
				body: {
					partNo: mainPartNo,
					mainPartNo: mainPartNo,
					productType: productType,
					quantity: totalQuantity,
					isClimateScreen: false,
					cutMeasure: JSON.stringify(this.cutMeasures),
				},
			});
			if (!this.hasCutMeasure) {
				(Alpine.store("basketNotification") as BasketNotificationStore).showNotification(productType);
			}
			Alpine.store("basket", res.data);
			await getOrderTotal();
			await addToCartTracking(mainPartNo, totalQuantity);
		},
		async addNewCutMeasure(mainPartNo, productType) {
			(Alpine.store("basketNotification") as BasketNotificationStore).showNotification(productType);
			this.cutMeasures.push({ cutLength: "1", noOfPieces: "1" });
			await this.upsertCutMeasure(mainPartNo, productType);
		},
		async changeCutMeasure(mainPartNo, productType) {
			if (!this.hasCutMeasure) {
				return;
			}
			await this.upsertCutMeasure(mainPartNo, productType);
		},
		init() {
			Alpine.effect(() => {
				const basket = this.$store.basket as Basket;
				if (basket) {
					this.hangerBasketLine = basket.items.find((x) => x.partNo === hangerProduct);
					this.cutSampleBasketLine = basket.items.find((x) => x.partNo === cutSampleProduct);
					this.sampleCardBasketLine = basket.items.find((x) => x.partNo === sampleCardProduct);
					this.cutMeasureBasketLine = basket.items.find((x) => x.partNo === cutMeasureProductId);
					if (this.cutMeasureBasketLine) {
						this.cutMeasures = this.cutMeasureBasketLine.cutMeasures;
						this.hasCutMeasure = true;
					} else {
						this.hasCutMeasure = false;
					}
				}
			});
		},
	};
};
